import { ALL_OPTION_KEY, NOT_SELECTABLE_KEY } from '../../../shared/components/option-toggle/option-toggle.component';
import { Department, DEPARTMENT_OPTIONS } from '../../../shared/types/department';
import { Option } from '../../../shared/types/option';
import { Role, ROLE_OPTIONS } from '../../../shared/types/role';
import { User, UserInviteContract, UserInviteContractV3 } from '../../../shared/types/user';

export enum UserStatus {
    Active = 'active',
    Pending = 'pending',
}

export enum UserRowType {
    User = 'user',
    Invite = 'invite',
}

export type SortColumn = 'name' | 'department' | 'role' | 'status';

export interface UserRow {
    id: string;
    type: UserRowType;
    firstName: string;
    lastName: string;
    email: string;
    role: Role | null;
    department: Department | null;
    dataCount: number;
    adminCount: number;
    status: UserStatus;
    managedOnV3?: boolean;
}

export function userToRow(user: User): UserRow {
    return {
        id: String(user.id),
        type: UserRowType.User,
        firstName: user.firstName ?? '',
        lastName: user.lastName ?? '',
        email: user.email ?? '',
        role: user.role,
        department: user.department ?? null,
        dataCount: user.properties.data ?? 0,
        adminCount: user.properties.admin ?? 0,
        status: UserStatus.Active,
    };
}

export function inviteToRow(invite: UserInviteContract): UserRow {
    return {
        id: invite.id,
        type: UserRowType.Invite,
        firstName: invite.firstName ?? '',
        lastName: invite.lastName ?? '',
        email: invite.email ?? '',
        role: invite.role,
        department: invite.department ?? null,
        dataCount: invite.propertyPrivileges.filter((p) => !p.isAdmin).length,
        adminCount: invite.propertyPrivileges.filter((p) => p.isAdmin).length,
        status: UserStatus.Pending,
    };
}

export function v3InviteToRow(invite: UserInviteContractV3): UserRow {
    return {
        id: invite.id,
        type: UserRowType.Invite,
        firstName: invite.firstName ?? '',
        lastName: invite.lastName ?? '',
        email: invite.email ?? '',
        role: null,
        department: invite.department ?? null,
        dataCount: 0,
        adminCount: 0,
        status: UserStatus.Pending,
        managedOnV3: true,
    };
}

export const ROLE_ICON: Record<Role, string> = {
    [Role.JuyoAdmin]: 'workspace_premium',
    [Role.OrganizationOwner]: 'workspace_premium',
    [Role.OrganizationAdmin]: 'shield',
    [Role.PropertyAdmin]: 'apartment',
    [Role.User]: 'person',
};

export const ROLE_CLASS: Record<Role, string> = {
    [Role.JuyoAdmin]: 'role-badge role-owner',
    [Role.OrganizationOwner]: 'role-badge role-owner',
    [Role.OrganizationAdmin]: 'role-badge role-org-admin',
    [Role.PropertyAdmin]: 'role-badge role-prop-admin',
    [Role.User]: 'role-badge role-user',
};

export const STATUS_OPTIONS: Option[] = [
    new Option(ALL_OPTION_KEY, 'All'),
    new Option('active', 'Active'),
    new Option('pending', 'Pending invite'),
];

export const ROLE_FILTER_OPTIONS: Option[] = [new Option(ALL_OPTION_KEY, 'All'), ...ROLE_OPTIONS];

export const DEPARTMENT_FILTER_OPTIONS: Option[] = [
    new Option(ALL_OPTION_KEY, 'All'),
    ...DEPARTMENT_OPTIONS.filter((o) => o.key !== NOT_SELECTABLE_KEY),
];
